<template>
  <div>
    <div class="control">
      <div
        style="width: auto; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2">
        <img src="../images/flow/编组43备份.png" /><span class="fontcss1">身份验证</span>
      </div>
      <div
        style="width: 20%; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2" style="color: #1e88ff">
        <img src="../images/flow/编组 89.png" /><span class="fontcss">风险测评</span>
      </div>
      <div style="width: 20%; height: 10px; border-bottom: 2px dashed #999999"></div>
      <div class="control2">
        <img src="../images/flow/编组6备份6.png" /><span class="fontcss2">电子签名</span>
      </div>
      <div style="width: auto; height: 10px; border-bottom: 2px dashed"></div>
    </div>
    <div>
      <div class="catalogue">
        <div class="catalogue3" @click="returnback">	&lt;返回</div>
        <div class="catalogue1" id="catalogue1" @click="contract">风险测评问卷</div>
        <!-- <div class="catalogue1" id="catalogue2" @click="prospectus">还款计划</div> -->
      </div>
      <div class="content">
        <div v-if="judge" class="content1">
          <!-- <span
            问题2 : 您计划投资多久？ A. 3年以上 B. 1至3年 C. 6个月至1年 D. 半年以下 问题3 : 通过我行投资基金的规模，预计占您金融性总资产的比例为多少？ A. 低于30% B. 30%至50% C. 50%至75% D. 高于70% 问题4 : 以下哪项描述正确反映了您的投资经验？ A. 丰富(5年以上)，且希望自主理财 B. 熟悉(3至5年)，但希望专业人士协助 一般(1至3年)，有一些理财意识 非常有限，不具备投资经验 Q5：您感觉目前负担的经济压力？ 非常轻松，完全没有压力 一般，基本没有压力 较大，但尚能承受 很大，还贷等负担较重 Q6：您在投资时最看重的是什么？ 每年获得稳定收益，获得长期收益 获得短期的高收益 在通货膨胀时资产不贬值 保住本金</span> -->
            <span>
              问题1 : 您的年龄？<br>
              <input type="radio" >A. 25到40岁<br>
              <input type="radio" >B. 40到50岁<br>
              <input type="radio" >C. 50到60岁<br>
              <input type="radio" >D. 60岁以上<br>
            </span>
            <span>
              问题2 : 您计划投资多久？<br>
              <input type="radio" >A. 3年以上 <br>
              <input type="radio" >B. 1至3年<br>
              <input type="radio" >C. 6个月至1年<br>
              <input type="radio" >D. 半年以下<br>
            </span>
            <span>
              问题3 : 通过我行投资基金的规模，预计占您金融性总资产的比例为多少？<br>
              <input type="radio" >A. 低于30% <br>
              <input type="radio" >B. 30%至50%<br>
              <input type="radio" >C. 50%至75% <br>
              <input type="radio" >D. 高于70% <br>
            </span>
            <span>
              问题4 : 以下哪项描述正确反映了您的投资经验？<br>
              <input type="radio" >A. 丰富(5年以上)，且希望自主理财 <br>
              <input type="radio" >B. 熟悉(3至5年)，但希望专业人士协助 一般(1至3年)，有一些理财意识 非常有限，不具备投资经验<br>
            </span>
            <span>
              Q5：您感觉目前负担的经济压力？ 非常轻松，完全没有压力 一般，基本没有压力 较大，但尚能承受 很大，还贷等负担较重<br>
            </span>
            <span>
              Q6：您在投资时最看重的是什么？ 每年获得稳定收益，获得长期收益 获得短期的高收益 在通货膨胀时资产不贬值 保住本金<br>
            </span>
            
          <!-- <span
            >本合同各方根据有关法律、法规及规章，在平等、自愿的基础上，为明确责任，恪守信用，签订本合同，并承诺共同遵守。</span
          >
          <span>
            第一条 定义
          </span>
          <span>
              1.1
              个人信用贷款：指由贷款人向符合特定条件的借款人发放的，用于个人合法合规用途的人民币贷款。</span
            >
            <span>
              1.2
              贷款人：网上银行、手机银行等自助渠道显示地区对应的工商银行经办分行或受理借款申请的营业网点所属的工商银行经办行，负责受理借款申请、贷款审批和发放，并与借款人签署本合同，同“贷款经办行”。</span
            > -->
        </div>
        <!-- <div v-else class="content1">
          <span>第五条 贷款申请、审   批与发放</span>
          <span>
            5.1
            借款人可通过网上银行、手机银行等渠道自助或通过营业网点申请办理个人信用贷款。通过网上银行、手机银行等渠道自助申请办理个人信用贷款业务的，借款人申请贷款前应当与贷款人签署《中国工商银行电子银行个人客户服务协议》，承诺遵守《中国工商银行电子银行章程》及相关的交易规定，并按照相关交易规则进行操作。</span
          >
          <span>
            5.2
            借款人须按照营业网点、网上银行、手机银行等提示及要求填写或选择贷款金额、贷款期限、贷款用途、还款方式等，确认或补充本人客户信息。借款人可通过网上银行、手机银行等渠道自助查询申办进度。</span
          >
        </div> -->
      </div>
      <div class="text1">
          完成后点击下方按钮推送问卷答题附件
           <div class="bnt1" @click="Verification" >推送问卷答案附件</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "flow",
  mounted(){
			this.getFile();
    	},
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      name: "李晓伟",
      base64Img:'',
    };
  },
  methods:{
    getFile(){
          const parames = {
            data: {
              fileCode:"001", 
            },
          };
          this.$_post(this.$API.getFile, parames).then(res => {
              let string= res.data.demoFiles.file1;
              this.base64Img = 'data:image/png;base64,'+string;
          });
      },
      contract(){
         this.judge=true
         this.switchover()
      },
      prospectus (){
          this.judge=false
          this.switchover()
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
          }
      },
      returnback(){
        this.$router.push({path:'/flow4'})
      },
      Verification(){
        if(true){
           this.$router.push({path:'/flow6'})
        }
      }
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.bnt {
  width: 300px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.control {
  width: 300px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 300px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 88%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
   width: 300px;
   height: 36px;
   background:#F3F3F3;
   display: flex;
   flex-direction: row;
   color: #09254C;
}
.catalogue1{
    width: 50%;
    /* height: 3rem; */
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 45px;
    font-size: 1rem;
}   
.catalogue3{
    width: 60px;
    height: 36px;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}  
.text1{
   width: 300px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 18px;
}
.fontcss2{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 18px;
}
</style>